"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var table_style_1 = require("../../components/table/table.style");
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-FormList',
    tableCell: 'c-FormList__TableCell',
    tableCellButton: 'c-FormList__TableCellButton',
    tableCellFaint: 'c-FormList__TableCell--faint',
    tableCellMenu: 'c-FormList__TableCell--menu'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = (_b = {},
        _b["& .".concat(table_style_1.CSS.container)] = {
            width: '80%',
            'margin-bottom': theme_1.DefaultTheme.space(6)
        },
        _b["& .".concat(table_style_1.CSS.header, " > th:last-of-type")] = {
            width: '100px'
        },
        _b["& .".concat(table_style_1.CSS.cell, ":last-of-type")] = {
            overflow: 'visible'
        },
        _b),
    _a[exports.CSS.tableCell] = {
        'text-overflow': 'ellipsis',
        overflow: 'hidden',
        'white-space': 'nowrap'
    },
    _a[exports.CSS.tableCellButton] = {
        padding: "0 ".concat(theme_1.DefaultTheme.space(1)),
        'text-align': 'left'
    },
    _a[exports.CSS.tableCellFaint] = {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[exports.CSS.tableCellMenu] = {
        display: 'flex',
        'justify-content': 'flex-end',
        overflow: 'visible'
    },
    _a);
//# sourceMappingURL=form.list.style.js.map